// Static site data faithful to acd-advogados.net

export const SITE = {
    name: "ACD Advogados",
    fullName: "Ana Cristina Domingues Advogados",
    tagline: "Assessoria Jurídica de Excelência desde 1995",
    logoUrl: "/images/wp/2026/04/logo-new_2021.png",
    whatsappNumber: "351966075157",
    whatsappUrl: "https://api.whatsapp.com/send?phone=351966075157",
    whatsappUrlAppointment: "https://wa.me/351966075157?text=Ol%C3%A1%2C%20equipa%20da%20ACD%20Advogados%21%20Estive%20a%20ver%20o%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado%20para%20analisar%20o%20meu%20caso.",
    email: "geral@acd-advogados.net",
    social: {
        facebook: "https://www.facebook.com/pages/category/Lawyer---Law-Firm/ACD-Advogados-251316588296912/",
        instagram: "https://www.instagram.com/acd_advogados/",
        linkedin: "https://www.linkedin.com/company/acd-advogados1995/",
    },
    offices: [
        {
            region: "Portugal Continental",
            city: "Escritório em Lisboa",
            address: "Pátio das Fragatas, Av. Dom João II Nº 3 B, Loja 22, 1990-607 Lisboa.",
            phones: ["21 716 76 64", "21 711 29 28"],
            note: "(Chamada para a rede fixa nacional)",
        },
        {
            region: "Açores",
            city: "Escritório Ponta Delgada",
            address: "Ed. Rotunda, Av. Natália Correia 2, 9500-341 Ponta Delgada.",
            phones: ["296 102 222"],
            note: "(Chamada para a rede fixa nacional)",
        },
    ],
};

export const HERO_SLIDES = [
    {
        title: "O Seu Futuro em Portugal com Segurança Legal",
        text: "Asseguramos uma integração tranquila e devidamente legalizada. Orientamos os nossos clientes em todos os processos de imigração e nacionalidade, promovendo a sua participação ativa na sociedade portuguesa.",
        cta: "Contacte a Nossa Equipa",
        link: "https://api.whatsapp.com/send?phone=351966075157",
        bg: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/nd0v3cg2_pexels-su-lopes-54155462-7789476.webp",
    },
    {
        title: "Assessoria Jurídica de Excelência para Empresas",
        text: "Protegemos os interesses do seu negócio com uma abordagem estratégica. Garantimos a total conformidade legal para que se possa focar no crescimento da sua empresa, apresentando soluções ágeis para desafios complexos.",
        cta: "Conhecer Planos de Avença",
        link: "https://api.whatsapp.com/send?phone=351966075157",
        bg: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/komhol4o_pexels-thorl5-2154653228-33672640.webp",
    },
    {
        title: "Atos Notariais e Balcão Único",
        text: "Simplificamos a burocracia. O nosso serviço de balcão único garante rapidez, segurança e rigor na validação de todos os seus documentos, tudo num só lugar.",
        cta: "Agendar Atendimento",
        link: "https://api.whatsapp.com/send?phone=351966075157",
        bg: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/lb5qx4qn_pexels-francesco-ungaro-33515014.webp",
    },
];

export const PARTNERS = [
    {
        title: "Eugenia Butkevich - Atuação Ibérica",
        desc: "Advocacia com exercício profissional em Espanha. Assegura vasta experiência e um sólido suporte jurídico multissetorial, garantindo a defesa constante dos seus interesses em todo o território espanhol.",
    },
    {
        title: "Juristas, Consultores, Advogados & Associados, Lda - Conexão África",
        desc: "Com sede em Maputo, Moçambique. Atuação integral em todas as áreas do Direito, com destaque histórico na elaboração de legislação de âmbito nacional.",
    },
    {
        title: "YUM, Lda - Tradução Jurídica Rápida",
        desc: "Mais de 25 anos de experiência em traduções técnicas e jurídicas. Garante capacidade de resposta rápida sob pressão, sem taxas de urgência adicionais.",
    },
    {
        title: "USP - Especialistas Multilingues",
        desc: "Equipa especializada em traduções de Inglês, Italiano, Francês, Romeno, Hindi e Gujarati. Assegura rigor técnico, cumprimento rigoroso de prazos e total confidencialidade.",
    },
];

export const AREAS_HOME = [
    {
        title: "Direito Penal & Contraordenacional",
        image: "/images/articles/seguranca_juridica.png",
        text: "Atuamos com vasta experiência no complexo panorama penal e contraordenacional, a nível nacional e internacional. Asseguramos uma representação incisiva na defesa e na acusação, protegendo com rigor os interesses e direitos de pessoas singulares e de entidades coletivas.",
        anchor: "direito-penal",
    },
    {
        title: "Direito Comercial e Financeiro",
        image: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/9b6puf4s_c432ba4fe1534d709616d02ce2100863_final_article_1_arrendamento.png",
        text: "Prestamos assessoria estratégica a sociedades comerciais na constituição, reestruturação e resolução de conflitos. Asseguramos ainda representação rigorosa em processos de insolvência, recuperação de crédito e nas mais diversas e complexas transações bancárias e financeiras.",
        anchor: "direito-comercial-e-financeiro",
    },
    {
        title: "Direito Civil",
        image: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/gf6suzfo_b46748ba641847b2b6dfa7fa644801d2_final_article_4_imt_jovem.png",
        text: "Garantimos assessoria e representação forense de excelência nos diversos ramos do Direito Civil. Acompanhamos de perto questões familiares como divórcios e partilhas, além de atuar com firmeza em contratos, arrendamentos, responsabilidade civil e recuperação de créditos.",
        anchor: "direito-civil",
    },
    {
        title: "Direito do Trabalho",
        image: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/5ykpwijk_08c740571d374165b04e3f30ac7b928d_final_article_2_teletrabalho.png",
        text: "Representamos empresas, sindicatos e trabalhadores nacionais ou estrangeiros em todas as esferas laborais. Oferecemos suporte completo em processos disciplinares, negociação de contratos coletivos, cessação de vínculos e na condução de contencioso ou contraordenações.",
        anchor: "direito-do-trabalho",
    },
    {
        title: "Direito Administrativo",
        image: "/images/articles/aima_imigracao.png",
        text: "Vocacionados para consultoria e acompanhamento integral de processos administrativos nas fases graciosa e contenciosa. Destacamo-nos na regularização de estrangeiros, registos de nacionalidade, recursos de anulação e em contencioso nas áreas de Urbanismo, Ambiente e Saúde.",
        anchor: "direito-administrativo",
    },
    {
        title: "Direito Fiscal e Tributário",
        image: "https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/ia3sbgmp_3b792dfe98ac4d54bfaf36bdc9dcff0a_final_article_3_saude_trabalho.png",
        text: "Oferecemos sólido aconselhamento e patrocínio a contribuintes perante os complexos desafios fiscais. Atuamos com rigor em procedimentos administrativos, inspeções tributárias e processos judiciais, incluindo defesa firme em execuções fiscais e processos de natureza criminal.",
        anchor: "direito-fiscal-e-tributario",
    },
];

export const AREAS_FULL = [
    {
        id: "direito-penal",
        title: "Direito Penal & Contraordenacional",
        body: [
            "O direito penal e das contraordenações assume um crescente relevo no panorama jurídico nacional e internacional. Temos vasta experiência neste domínio, tanto na perspetiva da defesa como da acusação, e prestamos serviços jurídicos a pessoas singulares e coletivas.",
        ],
    },
    {
        id: "direito-civil",
        title: "Direito Civil",
        body: [
            "Garantimos a assessoria e a representação forense dos nossos clientes nos mais diversos ramos do Direito Civil, com particular incidência em:",
        ],
        list: [
            "Divórcios;",
            "Responsabilidades parentais;",
            "Promoção e Protecção de Menores;",
            "Contencioso de Condomínios;",
            "Arrendamentos;",
            "Inventários e Partilhas Judiciais e Extrajudiciais;",
            "Responsabilidade Civil;",
            "Contratos e seus incumprimentos;",
            "Recuperação e cobranças de créditos;",
            "Testamentos.",
        ],
    },
    {
        id: "direito-do-trabalho",
        title: "Direito do Trabalho",
        body: [
            "Prestamos serviços em todas as áreas do Direito do Trabalho, em representação dos trabalhadores nacionais ou estrangeiros, das empresas ou das associações sindicais e outras, designadamente:",
        ],
        list: [
            "Instrução de processos disciplinares;",
            "Procedimentos de cessação das relações laborais;",
            "Apoio a processos de contratação coletiva;",
            "Condução de processos de contencioso laboral, incluindo ações emergentes de acidentes de trabalho e doenças profissionais;",
            "Condução de processos de contraordenação laboral.",
        ],
    },
    {
        id: "direito-administrativo",
        title: "Direito Administrativo",
        body: [
            "Estamos solidamente vocacionados para a consultadoria, a preparação e o acompanhamento dos mais variados processos administrativos, nas suas fases graciosas e contenciosas, particularmente:",
        ],
        list: [
            "Instrução e acompanhamento de processos de regularização e permanência de cidadãos estrangeiros em território nacional;",
            "Instrução e acompanhamento de processos de aquisição, atribuição e perda da nacionalidade portuguesa;",
            "Registo, prova e contencioso da nacionalidade;",
            "Ações administrativas;",
            "Processos de intimação;",
            "Recursos contenciosos de anulação;",
            "Regime de trabalho na Função Pública;",
            "Contencioso na área do Urbanismo, Ambiental, Saúde, Educação e Turismo.",
        ],
    },
    {
        id: "direito-fiscal-e-tributario",
        title: "Direito Fiscal e Tributário",
        body: [
            "Aconselhamento e patrocínio dos contribuintes no âmbito dos procedimentos administrativos, de inspeção tributária e graciosos, processos judiciais, incluindo processo de natureza criminal e execuções fiscais.",
        ],
    },
    {
        id: "direito-comercial-e-financeiro",
        title: "Direito Comercial e Financeiro",
        body: [
            "Estamos igualmente preparados para nos ocuparmos dos atos inerentes à atividade das sociedades comerciais, prestando assessoria jurídica geral a sociedades, com vista à sua reestruturação, incluindo a resolução de situações de conflito entre sócios ou entre estes e a sociedade, nomeadamente:",
        ],
        list: [
            "Constituição de sociedades;",
            "Transformação, fusão e cisão de sociedades;",
            "Dissolução e liquidação de sociedades;",
            "Acordos parassociais.",
        ],
        extra: [
            "Fazemos o acompanhamento das várias dimensões de um processo judicial de insolvência, sob a perspetiva dos credores, na defesa dos seus direitos de crédito. Garantimos ainda o acompanhamento do insolvente na pendência do processo judicial, também na defesa dos seus direitos e interesses.",
            "No âmbito do Direito Bancário e Financeiro procedemos à preparação e à negociação da mais variada documentação com relação a uma grande variedade de transações bancárias e financeiras, tais como contratos de empréstimo, documentos de garantias, cartas de crédito, transações no âmbito do direito bancário, financeiro e de \"project finance\", entre outros.",
        ],
    },
    {
        id: "arbitragem",
        title: "Arbitragem",
        body: [
            "A arbitragem como meio alternativo de resolução de litígios afirma-se hoje como uma solução privilegiada e eficaz para resolver alguns tipos de disputas a que os tribunais judiciais se têm mostrado incapazes de dar resposta em termos eficazes.",
        ],
    },
    {
        id: "direito-comunitario",
        title: "Direito Comunitário e da Concorrência",
        body: [
            "Damos resposta célere e adequada às questões colocadas pelos nossos clientes, independentemente das suas especificidades e complexidade. Distinguimo-nos pela qualidade dos serviços prestados, quer ao nível do aconselhamento, como ao nível do relacionamento com a Autoridade da Concorrência, em processos contraordenacionais ou em outros procedimentos administrativos e judiciais.",
        ],
    },
    {
        id: "direito-energia",
        title: "Direito da Energia e dos Recursos Naturais",
        body: [
            "Tendo em conta as necessidades dos nossos clientes, estamos particularmente vocacionados para prestar aconselhamento sobre recursos energéticos e apoio no desenvolvimento de projetos nesta área, quer a particulares quer a empresas.",
        ],
    },
    {
        id: "direito-publico",
        title: "Direito Público",
        body: [
            "De acordo com as exigências especificas dos nossos clientes, nacionais e estrageiros, encontramos sempre a solução que melhor sirva as suas necessidades, destacando, desde logo, a nossa vasta experiência na proteção dos direitos fundamentais.",
        ],
    },
    {
        id: "imobiliario",
        title: "Imobiliário",
        body: [
            "A nossa equipa possui um forte conhecimento técnico dos direitos reais e do direito registral, proporcionando eficácia, rapidez e qualidade de prestação de serviços nesta área.",
        ],
    },
    {
        id: "propriedade-intelectual",
        title: "Propriedade Intelectual",
        body: [
            "Asseguramos aconselhamento e assessoria jurídica especializada, nomeadamente no que respeita a marcas, desenhos industriais, proteção de patentes, direitos de autor, concorrência desleal, aquisição e manutenção de direitos de propriedade intelectual, bem como a sua defesa em caso de violação.",
        ],
    },
    {
        id: "seguros",
        title: "Seguros",
        body: [
            "Possuímos uma valiosa experiência no aconselhamento dos nossos clientes em todas as matérias respeitantes à atividade seguradora e na área conexa da responsabilidade civil.",
        ],
    },
    {
        id: "telecomunicacoes",
        title: "Telecomunicações e TI",
        body: [
            "Prestamos aconselhamento e assessoria jurídica aos operadores e investidores que atuam neste setor, assegurando da melhor forma a prossecução dos seus interesses. Assim como representamos e defendemos os interesses de particulares em litígios nesta área.",
        ],
    },
    {
        id: "contratos",
        title: "Contratos",
        body: [
            "Temos ainda vasta experiência quanto à elaboração e negociação de contratos, incluindo:",
        ],
        list: [
            "Contratos de empreitada, subempreitada e outros contratos de prestação de serviços;",
            "Contratos relativos a imóveis (v.g. compra e venda, arrendamento, exploração turística);",
            "Contratos relativos a estabelecimentos comerciais (v.g. trespasse, cessão de exploração).",
        ],
    },
    {
        id: "actos-notariais",
        title: "Actos Notariais",
        body: [
            "No quadro da inovação da prática dos actos notariais, e dando concretização aos princípios fundamentais desta, nomeadamente ao nível da celeridade, da simplificação e da desburocratização, os nossos advogados estão habilitados a praticar esses serviços, entre os quais:",
        ],
        list: [
            "Serviço de balcão único;",
            "Partilhas;",
            "Contratos de compra e venda e doação de imóveis;",
            "Constituição de propriedade horizontal e alteração do seu título constitutivo;",
            "Constituição e liquidação de Sociedades Civis;",
            "Constituição de Sociedades Comerciais;",
            "Contratos de Mútuo com ou sem hipoteca;",
            "Contratos de Promessa com eficácia real;",
            "Dação em Cumprimento;",
            "Divisão de Coisa Comum;",
            "Permutas;",
            "Alteração Contrato Societário (aumento, redução de capital, cisão, fusão, transformação);",
            "Liquidação, Unificação e Partilha de Quotas em Sociedades Comerciais;",
            "Reconhecimento de assinaturas simples e com menções especiais por semelhança ou presenciais;",
            "Certificação de fotocópias e documentos, em conformidade com os originais;",
            "Certificação de traduções;",
            "Termos de autenticação;",
            "Procurações;",
            "Formalização da constituição, alteração de estatutos, bem como de todos os atos e contratos necessários ao exercício de atividade de associações e fundações;",
            "Registo de Automóvel online e pedido de Certidões;",
            "Todos os Actos de Registo Comercial e Predial Online em geral não elencados supra e pedido de certidões.",
        ],
    },
];

export const SOCIAL_RESPONSIBILITY = [
    {
        title: "Associação Cultural Moinho da Juventude",
        url: "https://moinhodajuventude.com/",
        logo: "/images/wp/2026/04/transferir-1-qka1tdu84blwyemq7ks84o7em6cmofzbfffthqgws2.png",
        desc: "Nascida de um trabalho informal de animação de crianças, organização de mulheres e luta pelo saneamento básico, nos primeiros anos da década de 1980, assume-se hoje como um projeto comunitário. Sediada no Alto da Cova da Moura, as suas atividades desenvolvem-se a nível social, cultural e económico.",
    },
    {
        title: "Associação Supera-te",
        url: "https://www.superate.pt/",
        logo: "/images/wp/2026/04/Supera_teLOGO2023-GERAL-paraperfilredessociais-375w-150x150-1.webp",
        desc: "A Associação Supera-te nasce da experiência da Presidente Executiva, Cátia Sofia Silva, na sua vivência de 7 anos num relacionamento pautado com violência doméstica. Segue com a missão de apoiar outras famílias e inspirá-las a viverem uma vida extraordinária.",
    },
    {
        title: "Conselho Nacional de Estudantes de Direito",
        url: "https://www.cnedireito.net/",
        logo: "/images/wp/2026/04/transferir-150x150-1.png",
        desc: "O Conselho Nacional de Estudantes de Direito representa os estudantes de Direito em Portugal, defendendo interesses e direitos académicos. Promove debates e eventos que enriquecem a formação jurídica.",
    },
];

export const TESTIMONIALS = [
    {
        name: "Maria José Constantino",
        text: "Não tenho palavras suficientes para expressar o quanto admiro e recomendo o escritório ACD advogados! Desde o primeiro contacto, demonstraram um profissionalismo, empatia e dedicação absolutamente excecionais. Sentimo-nos sempre acompanhados, ouvidos e, acima de tudo, seguros com o apoio da equipa. A competência técnica aliada à humanidade com que tratam cada caso faz toda a diferença. Um verdadeiro exemplo de excelência no mundo jurídico!",
    },
    {
        name: "Susannah",
        text: "Este é um escritório de advocacia com preços justos. Tanto o meu pedido de reagrupamento familiar quanto o do meu amigo foram aprovados com sucesso graças ao trabalho deles, o que foi uma grande ajuda para nós. Num contexto em que o AIMA tem sido cada vez mais rigoroso na análise dos pedidos de reagrupamento familiar, sem dúvida tivemos sorte. Agradecemos muito o trabalho do escritório!",
    },
    {
        name: "Gonçalo Brito Câmara",
        text: "A equipa da ACD Advogados demonstrou um profissionalismo exemplar desde o primeiro contacto. Foram sempre claros, atenciosos e extremamente competentes na resolução do meu caso. Recomendo vivamente os seus serviços a quem procura aconselhamento jurídico de confiança em Lisboa.",
    },
    {
        name: "Miguel Ribeiro",
        text: "É difícil expressar o profundo sentimento de agradecimento que tenho de dar à equipa da ACD Advogados. Sempre me senti acompanhado na resolução da minha questão, com respostas rápidas e completas aos emails que enviei, com preços justos para o serviço que tão atenciosamente foi prestado. Para todos aqueles que optam por um trabalho de excelência, 30 anos de experiência que se sentem na exímia análise e feedback dado, a resposta é simples: façam como eu e optem sempre pela ACD Advogados.",
    },
];

export const PLANS = [
    {
        name: "ACD Particular",
        subtitle: "Ideal para proteção jurídica preventiva individual.",
        price: "79€",
        period: "/mês",
        featured: false,
        benefits: [
            "1 assunto jurídico por mês",
            "Análise detalhada de documentação",
            "1 resposta em parecer ou elaboração de documento (ex: Carta, Contrato)",
            "1 esclarecimento adicional sobre o tema",
            "Prazo normal de resposta: 5 dias úteis",
        ],
        note: "*Plano focado em pessoas singulares que procuram segurança jurídica no dia a dia.",
        cta: "https://wa.me/351966075157?text=Ol%C3%A1%2C%20equipa%20da%20ACD%20Advogados%21%20Estive%20a%20ver%20o%20site%20e%20tenho%20interesse%20no%20plano%20ACD%20Particular.",
    },
    {
        name: "ACD Empresa Base",
        subtitle: "Bom para microempresas e pequenas sociedades.",
        price: "149€",
        period: "/mês",
        featured: true,
        badge: "Mais Popular",
        benefits: [
            "2 assuntos jurídicos por mês",
            "Análise detalhada de documentação corporativa",
            "2 respostas em parecer ou elaboração de documentos (ex: Carta, Contrato)",
            "Esclarecimentos eventuais sobre os temas",
            "Prazo normal de resposta: 5 dias úteis",
        ],
        note: "*Ideal para blindar os primeiros passos e contratos do seu negócio.",
        cta: "https://wa.me/351966075157?text=Ol%C3%A1%2C%20equipa%20da%20ACD%20Advogados%21%20Estive%20a%20ver%20o%20site%20e%20tenho%20interesse%20no%20plano%20ACD%20Empresa%20Base.",
    },
    {
        name: "ACD Empresa Pro",
        subtitle: "Proteção total para empresas com demandas recorrentes.",
        price: "499€",
        period: "/mês",
        featured: false,
        benefits: [
            "Até 10 pedidos/assuntos por mês",
            "Análise detalhada de documentação",
            "Respostas escritas ou elaboração de documentos (ex: Carta, Contrato)",
            "Inclusão de 1 reunião de alinhamento mensal",
            "Prazo normal de resposta rápido: 2 dias úteis",
        ],
        note: "*Ideal para empresas com demandas jurídicas recorrentes e estratégicas.",
        cta: "https://wa.me/351966075157?text=Ol%C3%A1%2C%20equipa%20da%20ACD%20Advogados%21%20Estive%20a%20ver%20o%20site%20e%20tenho%20interesse%20no%20plano%20ACD%20Empresa%20Pro.",
    },
];

export const TEAM = [
    {
        name: "Dra. Ana Cristina Domingues",
        role: "Fundadora",
        photo: "/images/wp/2026/04/Ana-Cristina-Advocacia-Portugal.jpg",
    },
    {
        name: "Dra. Maria José Domingues",
        role: "Responsável Adjunta escritório ACD Advogados Lisboa",
        photo: "/images/wp/2026/05/Dra.-Maria-Jose-Domingues-Responsavel-Adjunta-escritorio-ACD-Advogados-Lisboa.jpg",
    },
    {
        name: "Dr. Bartolomeu Domingues",
        role: "Responsável Escritório ACD Advogados nos Açores",
        photo: "/images/wp/2026/05/Dr.-Bartolomeu-Domingues-Responsavel-Escritorio-ACD-Advogados-nos-Acores.-2.jpg",
    },
];

export const ABOUT_TEXT = {
    title: "Ana Cristina Domingues",
    paragraphs: [
        "Desde 1995, **Ana Cristina Domingues Advogados** tem um percurso marcado pela solidez e por uma visão de futuro, procurando antecipar as crescentes exigências de prestação de serviços de excelência. Oferece uma elevada qualificação, aliada a uma vasta experiência, como a melhor via para servir os seus clientes, prosseguindo valores ecuménicos de justiça, tolerância e paz.",
        "Com uma opção clara pela independência e uma forte aposta na qualidade dos serviços prestados, o escritório tem um percurso na vanguarda da inovação, assente num espírito de equipa. A sua atividade alicerça-se em princípios como o rigor, a transparência, o pragmatismo e o empenho, nunca esquecendo o mais escrupuloso cumprimento dos princípios deontológicos, contribuindo, deste modo, para a constante dignificação da prática da advocacia.",
        "Estes princípios basilares refletem-se no dia a dia da sua atividade e são servidos por uma permanente atualização da equipa nos aspetos técnicos, logísticos, ajustando esta atividade às necessidades dos clientes, sempre focada na procura da melhor solução possível.",
    ],
    bullets: [
        "Prezamos a independência, pois atuamos com tenacidade no exclusivo interesse dos nossos clientes, rejeitando dependências e corporativismos de qualquer espécie.",
        "A ambição e o empenho são as nossas principais caraterísticas, porque procuramos o sucesso dos nossos clientes e aceitamos sempre percorrer a distância necessária para o conseguir.",
        "Somos pragmáticos, porque privilegiamos a resolução prática dos assuntos que nos são confiados.",
    ],
    closing: [
        "Procuramos a perfeição e orgulhamo-nos do trabalho que produzimos. A busca da melhor defesa técnica para cada processo permite-nos resolver de forma eficiente todas as necessidades dos nossos clientes e parceiros. Por esse motivo, proporcionamos a melhor relação custo/benefício.",
        "A carteira de clientes do escritório é variada e abrange, para além dos clientes individuais, empresas das mais diversas áreas económicas, sociedades financeiras ou associações de imigrantes, de solidariedade social e sindicais, entre outras. As línguas trabalhadas são, para além da Portuguesa, o Francês, o Inglês e o Castelhano.",
    ],
};
